import comp from "./VisitorSignUp";
export default comp;
